import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useLoaderAtStartStore = defineStore('LoaderAtStartStore', () => {
  const visible = ref(true);
  const loaderIsRequired = ref(true);

  const showLoader = () => {
    visible.value = true;
  };

  return {
    visible, // TRUE while loader is on screen. Only for READ
    loaderIsRequired, // enable or disable loader
    showLoader,
  };
});
